import React from "react";
import { Box, Grid, Typography } from "@mui/material";
import { C2_FONT } from "./conecta2ModalStyles";
import { C2 } from "./Table/C2UserTable";

export const c2RtlFieldSx = {
  "& .MuiInputLabel-root": { right: 28, left: "auto", transformOrigin: "top right" },
  "& legend": { textAlign: "right" },
};

export default function C2FormSection({ icon: Icon, title, subtitle, children }) {
  return (
    <Box
      sx={{
        backgroundColor: "#FFFFFF",
        border: `1px solid ${C2.border}`,
        borderRadius: "16px",
        p: { xs: 2, sm: 2.5 },
      }}
    >
      <Box sx={{ display: "flex", alignItems: "center", gap: 1.25, mb: 2 }}>
        <Box
          sx={{
            width: 36,
            height: 36,
            borderRadius: "10px",
            backgroundColor: C2.lavender,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            flexShrink: 0,
          }}
        >
          <Icon sx={{ color: C2.violet, fontSize: 20 }} />
        </Box>
        <Box sx={{ minWidth: 0 }}>
          <Typography
            sx={{
              fontFamily: C2_FONT,
              fontWeight: 800,
              fontSize: "0.95rem",
              letterSpacing: "0.04em",
              textTransform: "uppercase",
              color: C2.sidebar,
            }}
          >
            {title}
          </Typography>
          {subtitle ? (
            <Typography sx={{ fontFamily: C2_FONT, fontSize: "0.8rem", color: C2.muted }}>
              {subtitle}
            </Typography>
          ) : null}
        </Box>
      </Box>
      <Grid container spacing={2}>
        {children}
      </Grid>
    </Box>
  );
}
